"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseCountryStrings = void 0;
var parseCountryStrings = exports.parseCountryStrings = function parseCountryStrings(countryStrings) {
  var countries = countryStrings.map(function (str) {
    var array = str.split('|');
    return {
      id: Number(array[0]),
      name_ru: array[1],
      name_en: array[2],
      kind: array[3],
      country_code: array[4],
      visaAvailability: array[11],
      countryNameRU: array[5],
      countryNameEN: array[6],
      link: array[7],
      priority: Number(array[8]),
      stars: Number(array[10])
    };
  });
  return countries;
};